import Pagination from '@/components/Shared/Pagination';

interface BlogPaginationProps {
  classModifier: string;
  totalRecords: number;
  currentPage: number;
  pageSize: number;
  url: string;
  onChange?: () => void;
  reverse?: boolean;
}
const BlogPagination = (props: BlogPaginationProps) => {
  const { classModifier, totalRecords, currentPage, pageSize, reverse } = props;
  const wrap: (pagination: React.ReactNode) => JSX.Element = pagination => (
    <div className={`blog-pagination blog-pagination--${classModifier}`} data-testid={`pagination-${classModifier}`}>
      {pagination}
    </div>
  );
  return (
    <Pagination
      totalRecords={totalRecords}
      currentPage={currentPage}
      pageSize={pageSize}
      reverse={reverse}
      wrap={wrap}
    />
  );
};

export default BlogPagination;
